import listActions from 'src/modules/event/list/eventListActions';
import EventService from 'src/modules/event/eventService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'EVENT_DESTROY';

const eventDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: eventDestroyActions.DESTROY_STARTED,
      });

      await EventService.destroyAll([id]);

      dispatch({
        type: eventDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.event.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/event');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: eventDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: eventDestroyActions.DESTROY_ALL_STARTED,
      });

      await EventService.destroyAll(ids);

      dispatch({
        type: eventDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.event.destroyAll.success'),
      );

      getHistory().push('/event');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: eventDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default eventDestroyActions;
